import styled from "styled-components";
import React from "react";
import Button from "../../UI/Button";
import { Link } from "react-router-dom";

export const SectionIntroduce = () => {
  return (
    <div className="bs-container">
      <Styles>
        <div className="introduce-left">
          <NumberText>01</NumberText>
          <h2>GIỚI THIỆU</h2>
          <p>
            Giải Âm nhạc Cống hiến do báo Thể thao và Văn hóa/TTXVN khởi xướng
            và tổ chức đã diễn ra từ năm 2005 với sự tham gia bầu chọn của báo
            giới toàn quốc. Trải qua 16 lần trao giải, năm 2023, báo Thể thao và
            Văn hóa quyết định mở rộng Giải Âm nhạc Cống hiến thành Giải Cống
            hiến nhằm vinh danh các sản phẩm, nhân vật, sự kiện trên cả hai lĩnh
            vực âm nhạc và thể thao; đồng thời thay đổi phương thức bầu chọn,
            nhằm thu hút được đa dạng hơn những ý kiến từ công chúng, nhà chuyên
            môn.
          </p>
          <Link to="/the-le">
            <Button>
              Xem thêm
              <img src="/images/right-arrow-2.png" />
            </Button>
          </Link>
        </div>
        <div className="introduce-right">
          <img src="/images/introduce.png" />
        </div>
      </Styles>
    </div>
  );
};

const Styles = styled.div`
  background: #2e2646;
  border-radius: 16px;
  padding: 17px 79px 72px;
  margin-top: 123px;
  display: flex;
  align-items: center;
  gap: 135px;
  > div {
    width: 50%;
  }

  h2 {
    font-size: 40px;
    font-weight: 700;
    white-space: nowrap;
    margin: 0;
  }

  .introduce-left {
    p {
      margin: 19px 0 28px;
    }

    button {
      height: 48px;
      img {
        margin-left: 8px;
      }
    }
  }

  .introduce-right {
    background: linear-gradient(to right, #a15bff, #ff8a5a);
    border-radius: 24px;

    img {
      border-radius: 24px;
      transform: translate(-11px, -11px);
      max-width: 100%;
    }
  }

  @media only screen and (max-width: 1199px) {
    gap: 40px;
    h2 {
      font-size: 28px;
    }
  }

  @media only screen and (max-width: 991px) {
    padding: 17px 40px 72px;
    margin-top: 80px;
    .introduce-left {
      width: 100%;
    }
    .introduce-right {
      display: none;
    }
  }

  @media only screen and (max-width: 480px) {
    padding: 17px 20px 40px;
    h2 {
      font-size: 24px;
    }
  }
`;

export const NumberText = styled.div`
  font-size: 100px;
  color: #2e2646;
  font-weight: 700;
  text-shadow: 1px 0 #fff, -1px 0 #fff, 0 1px #fff, 0 -1px #fff, 1px 1px #fff,
    -1px -1px #fff, 1px -1px #fff, -1px 1px #fff;
`;
